module.exports = require("graphql-request");